import Arweave from 'arweave';
import { LoggerFactory } from '..';
import Transaction from 'arweave/node/lib/transaction';
import 'redstone-isomorphic';
export class ArweaveWrapper {
    constructor(arweave) {
        this.arweave = arweave;
        this.logger = LoggerFactory.INST.create('ArweaveWrapper');
        this.baseUrl = `${arweave.api.config.protocol}://${arweave.api.config.host}:${arweave.api.config.port}`;
        this.logger.debug('baseurl', this.baseUrl);
    }
    async info() {
        try {
            const response = await fetch(`${this.baseUrl}/info`)
                .then((res) => {
                return res.ok ? res.json() : Promise.reject(res);
            })
                .catch((error) => {
                var _a;
                if ((_a = error.body) === null || _a === void 0 ? void 0 : _a.message) {
                    this.logger.error(error.body.message);
                }
                throw new Error(`Unable to retrieve info. ${error.status}.`);
            });
            return response;
        }
        catch (e) {
            this.logger.error('Error while loading network info', e);
            throw e;
        }
    }
    async gql(query, variables) {
        try {
            const data = JSON.stringify({
                query: query,
                variables: variables
            });
            const response = await fetch(`${this.baseUrl}/graphql`, {
                method: 'POST',
                body: data,
                headers: {
                    'Accept-Encoding': 'gzip, deflate, br',
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }
            })
                .then((res) => {
                return res.ok ? res.json() : Promise.reject(res);
            })
                .catch((error) => {
                var _a;
                if ((_a = error.body) === null || _a === void 0 ? void 0 : _a.message) {
                    this.logger.error(error.body.message);
                }
                throw new Error(`Unable to retrieve gql page. ${error.status}.`);
            });
            return {
                data: response,
                status: 200
            };
        }
        catch (e) {
            this.logger.error('Error while loading gql', e);
            throw e;
        }
    }
    async tx(id) {
        const response = await fetch(`${this.baseUrl}/tx/${id}`)
            .then((res) => {
            return res.ok ? res.json() : Promise.reject(res);
        })
            .catch((error) => {
            var _a;
            if ((_a = error.body) === null || _a === void 0 ? void 0 : _a.message) {
                this.logger.error(error.body.message);
            }
            throw new Error(`Unable to retrieve tx. ${error.status}.`);
        });
        return new Transaction({
            ...response
        });
    }
    async txData(id) {
        const response = await fetch(`${this.baseUrl}/${id}`);
        if (!response.ok) {
            throw new Error(`Unable to load tx data ${id}`);
        }
        const buffer = await response.arrayBuffer();
        return Arweave.utils.bufferToString(buffer);
    }
}
//# sourceMappingURL=ArweaveWrapper.js.map